import { Controller, useForm } from "react-hook-form";
import { createAddTrailerVehicleScheme } from "../../../validations/createVehicleScheme";
import { LoadingButton } from "@mui/lab";
import styled from "styled-components";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  ImageListItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { ReactComponent as CrossBtn } from "../../../assets/svg/cross.svg";
import LableComponent from "../../LableComponent";
import { useTranslation } from "react-i18next";

const AddTrailerForm = ({
  disableSubmit,
  uploadedImage,
  handleFileUploadChange,
  handleFileUploadClick,
  handleRemoveFile,
  uploadedInsurance,
  handleInsuranceFileUploadChange,
  handleInsuranceFileUploadClick,
  handleInsuranceRemoveFile,
  submitForm,
  errorMessage,
}) => {
  const [isSaveButton, setSaveButton] = useState(false);
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(createAddTrailerVehicleScheme),
  });

  return (
    <form
      onSubmit={handleSubmit((data) => {
        submitForm(data, isSaveButton);
      })}
    >
      <Stack spacing={2} sx={{ minHeight: "60vh", overflow: "auto" }}>
        <Controller
          name="trailerNumber"
          defaultValue=""
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              name="trailerNumber"
              type="trailerNumber"
              label={
                <LableComponent customLable={t("pages.addVehicle.text10")} />
              }
              error={!!errors.trailerNumber}
              helperText={errors?.trailerNumber?.message}
              style={{ marginTop: 5 }}
            />
          )}
        ></Controller>
        <Controller
          name="plateNumber"
          defaultValue=""
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              name="plateNumber"
              type="plateNumber"
              label={
                <LableComponent customLable={t("pages.addVehicle.text06")} />
              }
              error={!!errors.plateNumber}
              helperText={errors?.plateNumber?.message}
            />
          )}
        ></Controller>
        {errorMessage && (
          <Typography>
            <span style={{ color: "#C50F1F" }}>{errorMessage}</span>
          </Typography>
        )}
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="customLable" color="common.inputCustomLable">
            {t("components.addPersonalVehicleForm.text03")}
            <span style={{ color: "#C50F1F" }}></span>
          </Typography>
          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            style={{
              backgroundColor: "#fff",
              color: "#1D5AB9",
              borderWidth: 1,
              borderColor: "#1D5AB9",
              width: 110,
              height: 24,
              marginTop: 3,
              borderRadius: 0,
            }}
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 14,
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {t("commonLabels.text19")}
            </Typography>
            <VisuallyHiddenInput
              type="file"
              onChange={handleFileUploadChange}
              onClick={handleFileUploadClick}
              accept="image/png, image/jpeg, application/pdf"
            />
          </Button>
        </div>
        {uploadedImage && (
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <ImageListItem
              sx={{
                border: "1px solid lightgray",
              }}
            >
              <img
                alt=""
                style={{
                  width: 60,
                  height: 60,
                  border: 1,
                  borderWidth: 1,
                  borderColor: "gray",
                  borderRadius: 8,
                }}
                loading="lazy"
                src={URL.createObjectURL(uploadedImage)}
              />
            </ImageListItem>
            <button
              onClick={handleRemoveFile}
              style={{
                width: 15,
                height: 15,
                background: "transparent",
                border: 0,
                position: "relative",
                marginLeft: -10,
                marginTop: -5,
              }}
            >
              <CrossBtn
                style={{
                  width: 15,
                  height: 15,
                }}
              />
            </button>
          </div>
        )}
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="customLable" color="common.inputCustomLable">
            {t("components.addPersonalVehicleForm.text05")}{" "}
            <span style={{ color: "#C50F1F" }}>*</span>
          </Typography>

          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            style={{
              backgroundColor: "#fff",
              color: "#1D5AB9",
              borderWidth: 1,
              borderColor: "#1D5AB9",
              width: 110,
              height: 24,
              marginTop: 3,
              borderRadius: 0,
            }}
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 14,
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {t("commonLabels.text19")}
            </Typography>
            <VisuallyHiddenInput
              type="file"
              onChange={handleInsuranceFileUploadChange}
              onClick={handleInsuranceFileUploadClick}
              accept="image/png, image/jpeg, application/pdf"
              //required
            />
          </Button>
        </div>
        {uploadedInsurance && (
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <ImageListItem
              sx={{
                border: "1px solid lightgray",
              }}
            >
              <img
                alt=""
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                }}
                loading="lazy"
                src={URL.createObjectURL(uploadedInsurance)}
              />
            </ImageListItem>

            <button
              onClick={handleInsuranceRemoveFile}
              style={{
                width: 15,
                height: 15,
                background: "transparent",
                border: 0,
                position: "relative",
                marginLeft: -10,
                marginTop: -5,
              }}
            >
              <CrossBtn style={{ width: 15, height: 15 }} />
            </button>
          </div>
        )}
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <LoadingButton
            sx={{ mt: 5, mb: 5 }}
            size="large"
            type="submit"
            variant="outlined"
            color="primary"
            fullWidth
            disabled={disableSubmit || !isValid}
            onClick={() => {
              setSaveButton(true);
            }}
          >
            + {t("commonLabels.text20")}
          </LoadingButton>
        </div>
      </Stack>
    </form>
  );
};

export default AddTrailerForm;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
